module.exports = __webpack_public_path__ + "img/hud-musevis.1cc5dfaa.png";